import Link from 'gatsby-link'
import styled from 'styled-components'
import {fonts, fontSizes, fontWeights} from '../../theme'

const TextLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: white;
  font-weight: ${fontWeights.regular};
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[0]+'px'};
  margin-left: 8px;
  text-align: center;
`

export default TextLink





// WEBPACK FOOTER //
// ./src/elements/Text/TextLink.js